import React, { createContext, useContext, useEffect, useState } from "react";

const LanguageContext = createContext();

const languageFiles = {
  HU: () => import("./locales/hu.json"),
  EN: () => import("./locales/en.json"),
  SK: () => import("./locales/sk.json"),
  DE: () => import("./locales/de.json")
};

const countryToLang = {
  HU: "HU",
  SK: "SK",
  DE: "DE",
  AT: "DE",
  CH: "DE"
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("HU");
  const [dict, setDict] = useState({});

  // Detect country on first load
  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then(res => res.json())
      .then(data => {
        const country = data.country_code;
        // Always default to Hungarian, only switch if a supported country and not Hungary
        if (country === 'HU') {
          setLang('HU');
        } else if (countryToLang[country]) {
          setLang(countryToLang[country]);
        } else {
          setLang('HU'); // fallback to Hungarian for any unknown or failed detection
        }
      })
      .catch(() => setLang("HU")); // fallback to Hungarian on error
  }, []);

  // Load dictionary for all 4 languages
  useEffect(() => {
    languageFiles[lang]?.().then(mod => setDict(mod.default || mod));
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, dict }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
